<header class="header w-100">
  <div class="top-bar">
    <div class="container d-flex justify-content-end align-items-center px-3 py-2">
      <a
        [href]="translationService.t().mijnUrl"
        class="top-bar-link mijn-essent crnt-typography-body-functional d-flex align-items-center gap-2"
      >
        <crnt-icon icon="user"></crnt-icon>
        {{ mijnText() }}
      </a>
    </div>
  </div>
  <nav class="main-nav">
    <div class="container d-flex align-items-center gap-4 px-3 py-4">
      <div class="logo">
        <a [href]="translationService.t().homeUrl" [aria-label]="brandName() + ' homepage'">
          <img [src]="translationService.t().logoPathTop" [alt]="brandName()" class="logo-image" />
        </a>
      </div>
    </div>
  </nav>
</header>
